import { FaInstagram, FaEnvelope, FaYoutube } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <nav className="footer-nav">
          <ul>
            <li><Link to="/faq">FAQs</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/refund-policy">Refund Policy</Link></li>
            <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
            <li><Link to="/account-deletion">Account & Data Deletion</Link></li>
            <li><a href="https://www.rskonlineservices.com/contact" target="_blank" rel="noopener noreferrer">Contact Us</a></li>
          </ul>
        </nav>
        
        <div className="footer-social">
          <a href="https://www.instagram.com/rskpay" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-link"><FaInstagram /></a>
          <a href="https://www.youtube.com/@Rskpay" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="social-link"><FaYoutube /></a>
          <a href="mailto:admin@rskonlineservices.com" aria-label="Email" className="social-link"><FaEnvelope /></a>
        </div>
        
        <p className="footer-copyright">
         Copyright ©2026 R.S.K. Online Services Pvt Ltd. All Rights Reserved | CIN - U74999MH2021PTC361438 | GSTIN - 27AALCR0371H1ZV
        </p>
      </div>
    </footer>
  );
}

export default Footer;
